import { Box, Link, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import PDFViewers from './pdfViewer';

import closeIcon from '../../../../../assets/svg/whiteClose.svg';
import downloadIcon from '../../../../../assets/svg/whiteDownload.svg';
import {
  IMAGE_FILE_TYPES,
  VIDEO_FILE_TYPES,
  PDF_FILE_TYPE,
} from '../../../../../constants/fileTypeConstants';
import {
  IMAGE_MIME_TYPES,
  VIDEO_MIME_TYPES,
  PDF_MIME_TYPE,
} from '../../../../../constants/mimeTypeConstants';

interface AttachmentPopUpProps {
  handleClose: () => void;
  download: () => void;
  fileType: string;
  url: string;
  fileName: string;
}

const getFileTypeCategory = (fileType: string) => {
  const MEDIA_MIME_TYPES = IMAGE_MIME_TYPES.concat(VIDEO_MIME_TYPES);
  const FILE_TYPES = IMAGE_FILE_TYPES.concat(VIDEO_FILE_TYPES);

  if (FILE_TYPES.includes(fileType)) return 'media';
  if (MEDIA_MIME_TYPES.includes(fileType)) return 'media';
  if (PDF_FILE_TYPE === fileType) return 'pdf';
  if (PDF_MIME_TYPE === fileType) return 'pdf';

  return 'document';
};

function getMediaType(fileType: string) {
  if (IMAGE_FILE_TYPES.includes(fileType)) return 'img';
  if (IMAGE_MIME_TYPES.includes(fileType)) return 'img';
  if (VIDEO_FILE_TYPES.includes(fileType)) return 'video';
  if (VIDEO_MIME_TYPES.includes(fileType)) return 'video';

  return 'img';
}

const IconStyle = {
  width: '32px',
  height: '32px',
  borderRadius: '10px',
  padding: 0.5,
  '&:hover': {
    bgcolor: 'grey',
    borderRadius: '6px',
    cursor: 'pointer',
  },
};

const AttachmentPopUp = ({
  handleClose,
  download,
  fileType,
  url,
  fileName,
}: AttachmentPopUpProps) => {
  const [fileTypeCategory, setFileTypeCategory] = useState<string>('');

  useEffect(() => {
    setFileTypeCategory(getFileTypeCategory(fileType));
  }, [fileType]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#000000cc',
        position: 'fixed',
        zIndex: 1000,
        top: -10,
        left: 0,
      }}
    >
      <Stack
        direction='row'
        justifyContent='space-between'
        width='100%'
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          padding: '10px 10px',
          zIndex: 99999,
        }}
      >
        <Typography
          sx={{
            color: '#FFFFFF',
          }}
        >
          {fileName}
        </Typography>
        <Stack direction='row' spacing={1}>
          <Box
            sx={IconStyle}
            component='img'
            src={downloadIcon}
            onClick={download}
          />
          <Box
            sx={IconStyle}
            component='img'
            src={closeIcon}
            onClick={handleClose}
          />
        </Stack>
      </Stack>

      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          minWidth: fileTypeCategory === 'document' ? '500px' : 'auto',
          width: 'auto',
          height: fileTypeCategory === 'document' ? '90%' : 'auto',
          transform: 'translate(-50%, -50%)',
        }}
      >
        {fileTypeCategory === 'media' && (
          <Box
            component={getMediaType(fileType)}
            controls
            src={url}
            sx={{
              maxHeight: '80vh',
            }}
          />
        )}
        {fileTypeCategory === 'pdf' && <PDFViewers fileName={url} />}
        {fileTypeCategory === 'document' && (
          <Typography>
            <FormattedMessage
              defaultMessage='Cant preview this file. {link} to download'
              values={{
                link: (
                  <Link href='#' onClick={download}>
                    Click here
                  </Link>
                ),
              }}
            />
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AttachmentPopUp;
